const server =
  process.env.NODE_ENV === "development"
    ? process.env.VUE_APP_SERVER
    : location.origin;

const files = process.env.VUE_APP_FILES;

const menu = [
  {
    text: "Início",
    to: "/",
  },
  {
    text: "Perfil",
    to: "/perfil",
  },
  {
    text: "História",
    to: "/historia",
  },
  {
    text: "Equipe",
    to: "/equipe",
  },
  {
    text: "Coberturas",
    dropdown: [{ text: "Todas", to: "/coberturas" }],
    callback(component) {
      component.$rest("events-categories").list.forEach((category) => {
        this.dropdown.push({
          text: category.title,
          to: `/${category.slug}`,
        });
      });
    },
  },
  {
    text: "Almanaque",
    to: "/almanaque",
  },
  {
    text: "Blog",
    to: "/blog",
  },
  {
    text: "Contato",
    to: "/contato",
  },
  {
    text: "FeijoVip",
    to: "https://www.instagram.com/feijovipsinop/",
  },
];

export { server, files, menu };
